import Card from "components/Card";
import Page from "components/Page";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Nav, NavItem, NavLink } from "reactstrap";
import styles from "../OfficeStaffInformation.module.scss";

const PageWrapperStaffInformation = ({
  officeName,
  activeTab,
  tabName,
  manageTab,
  children,
  title,
  switchOwner = null,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const goToPreviousScreen = () => history.goBack();

  return (
    <Page
      onBack={goToPreviousScreen}
      className={styles["notes_main_parent_wrapper"] + " scheduler-page"}
      title={title}
      dynamicClassForTitle={"titles_simillar"}
    >
      <p className="pms_subtitle">{officeName || null}</p>
      {switchOwner}
      <Card className={styles["notes_main_card"]}>
        <div className="common-tabs scheduler-tabs">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === tabName.office ? "active" : ""}
                onClick={() => manageTab(tabName.office)}
              >
                {t("accountOwner.office")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === tabName.ownerManager ? "active" : ""}
                onClick={() => manageTab(tabName.ownerManager)}
              >
                {t("accountOwner.ownerManager")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === tabName.staff ? "active" : ""}
                onClick={() => manageTab(tabName.staff)}
              >
                {t("accountOwner.staff")}
              </NavLink>
            </NavItem>
          </Nav>
          {children}
        </div>
      </Card>
    </Page>
  );
};
export default PageWrapperStaffInformation;
